module.exports = __webpack_public_path__ + "img/Logo-17.f027c1b7.svg";